'use strict';
const flattenIdeas = require('@mindmup/mapjs-core/src/content/flatten-ideas'),
	traverse = require('@mindmup/mapjs-core/src/content/traverse'),
	asyncIterator = require('./async-iterator'),
	observable = require('@mindmup/mapjs-core/src/util/observable'),
	PASTE_TOO_LARGE = 'paste-too-large',
	getSize = (contents) => {
		return new TextEncoder().encode(JSON.stringify(contents)).length;
	};
module.exports = function ClipboardModel(mapModel, mapThemeModel, optional) {
	let doPasteAsRoot = false;
	const obs = observable(this),
		packers = (optional && optional.packers) || [],
		unpackers = (optional && optional.unpackers) || [],
		autoThemedIdeaUtils = (optional && optional.autoThemedIdeaUtils) || require('@mindmup/mapjs-core/src/content/auto-themed-idea-utils'),
		getSelectedIdeas = function () {
			const idea = mapModel.getIdea(),
				nonDuplicatedIdeas = () => {
					const cloned = idea.cloneMultiple(mapModel.getActivatedNodeIds()),
						childIds = [],
						traverseIterator = (node, level) => {
							if (level > 1) {
								childIds.push(node.id);
							}
						},
						childFilter = node => !childIds.includes(node.id);
					cloned.forEach(item => {
						traverse(item, traverseIterator, false, 1);
					});
					return cloned.filter(childFilter);
				},
				result = nonDuplicatedIdeas(), //idea.cloneMultiple(mapModel.getActivatedNodeIds()),
				ideaList = flattenIdeas(result);
			packers.forEach(packer => packer.pack(ideaList));
			return result;
		},
		unpackContents = function (contents) {
			const ideaList = flattenIdeas(contents);
			return asyncIterator(unpackers, unpacker => unpacker.unpack(ideaList));
		},
		sendContext = () => {
			obs.dispatchEvent('context', {
				pasteAsRoot: doPasteAsRoot
			});
		},
		setPasteAsRoot = newValue => {
			doPasteAsRoot = newValue;
			sendContext();
		},
		isEnabled = function () {
			return mapModel.getInputEnabled();
		},
		cut = function () {
			if (!isEnabled()) {
				return false;
			}
			const result = getSelectedIdeas();
			mapModel.getIdea().removeMultiple(mapModel.getActivatedNodeIds());
			return result;
		},
		pasteAsRoot = () => setPasteAsRoot(true),
		pasteAsChild = () => setPasteAsRoot(false),
		copy = () => {
			if (!isEnabled()) {
				return false;
			}
			return getSelectedIdeas();
		},
		paste = async (contents) => {
			if (!mapModel.isEditingEnabled()) {
				throw 'map model is not editable';
			}
			if (!isEnabled()) {
				throw 'map model input is disabled';
			}
			obs.dispatchEvent('paste-started');
			const idea = mapModel.getIdea(),
				pasteToParentId = (doPasteAsRoot && idea.id) || mapModel.getSelectedNodeId();
			try {
				await  unpackContents(contents);
				if (optional && optional.goldFileChangesModel) {
					const maxChangeSize = await optional.goldFileChangesModel.getMaxChangeSize(),
						maxSize = Number.isFinite(maxChangeSize) && (maxChangeSize - 1024),
						contentSize = maxSize && getSize(contents);
					if (contentSize && maxSize && contentSize > maxSize) {
						throw PASTE_TOO_LARGE;
					}
				}

				const result = autoThemedIdeaUtils.pasteMultiple(idea, mapThemeModel.getTheme(), pasteToParentId, contents);
				if (result && result[0]) {
					mapModel.selectNode(result[0]);
				}
				obs.dispatchEvent('paste-complete');
			} catch (reason) {
				if (reason === PASTE_TOO_LARGE) {
					obs.dispatchEvent(reason);
				} else {
					console.log('paste-failed', reason);
					obs.dispatchEvent('paste-failed');
				}
			}
		};
	Object.assign(this, {isEnabled, cut, pasteAsRoot, pasteAsChild, copy, paste});
};
